module.exports = __webpack_public_path__ + "img/belgium-logo-icon.a7c20317.png";